import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import API from "../../../utils/API";
import SectionHeader from "../../../components/views/SectionHeader";
import TabsContainer from "../../../components/views/TabsContainer";
import SectionFooter from "../../../components/views/SectionFooter";
import LoadingWizard from "../../../components/spinner/wizard";
import InputField from "../../../components/inputs/inputField";
import ToggleField from "../../../components/inputs/toggleField";
import SelectField from "../../../components/inputs/selectField";
import CreateRegistrationFlowTicketModal from "./modals/createRegistrationFlowTicketModal";
import EditTicketModal from "./modals/editTicketModal";
import DeleteTicketModal from "./modals/deleteTicketModal";
import DuplicateTicketModal from "./modals/duplicateTicketModal";
import PagePreviewFrame from "../../../views/pages/components/pagePreviewFrame";
import FormBuilderModal from '../../event/forms/modals/formBuilder';
import RichTextEditor from "../../../views/pages/components/richTextEditor";
import PageBuilderModal from "./pageEditor"
import * as IFrame from "react-iframe-form";
import TemplateCenterModal from '../../event/emails/modals/templateCenterModal';
// import Submissions from "../forms/submissions";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import TicketItem from "../../../components/tickets/TicketItem";
import DeleteFlowModal from "./modals/deleteFlowModal";
import TimeField from "../../../components/inputs/timeField";
import EmailEditor from '../../../components/email/emailEditor';
// import Payments from "./payments";

const ENV =
    process.env.NODE_ENV === "production"
        ? window.location.href.includes("planner.simple.events")
            ? `https://admin-api.simple.events/`
            : `https://beta-api.simple.events/`
        : `http://${window.location.hostname}:5015/`;

const baseFieldList = [
    {
        _id: "attendee",
        title: "Attendee Basic Detail Fields",
        fields: [
            {
                _id: "_firstName",
                fieldName: "First Name",
                fieldType: "text",
                required: true,
                propertyType: "attendee",
            },
            {
                _id: "_lastName",
                fieldName: "Last Name",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_email",
                fieldName: "Email",
                fieldType: "email",
                required: true,
                propertyType: "attendee",
            },
            {
                _id: "_phoneNumber",
                fieldName: "Phone Number",
                fieldType: "tel",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_title",
                fieldName: "Title",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_company",
                fieldName: "Company",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_textMessageOptIn",
                fieldName: "Text Message Opt In",
                fieldType: "checkbox",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_dietaryPreference",
                fieldName: "Dietary Preference",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_foodAllergies",
                fieldName: "Food Allergies",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_emergencyContactName",
                fieldName: "Emergency Contact Name",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_emergencyContactPhoneNumber",
                fieldName: "Emergency Contact Phone Number",
                fieldType: "tel",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_address",
                fieldName: "Address",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_address2",
                fieldName: "Address 2",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_city",
                fieldName: "City",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_state",
                fieldName: "State",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_zip",
                fieldName: "Zip",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_country",
                fieldName: "Country",
                fieldType: "text",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_profilePicture",
                fieldName: "Profile Picture",
                fieldType: "profileImage",
                required: false,
                propertyType: "attendee",
            },
            {
                _id: "_NPINumber",
                fieldName: "NPI Number",
                fieldType: "NPINumber",
                required: false,
                propertyType: "attendee",
            },
        ],
    },
    {
        _id: "rooming",
        title: "Attendee Rooming Fields",
        fields: [
            {
                _id: "_roomingInformation-arrivalDate",
                fieldName: "Arrival Date",
                fieldType: "date",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-arrivalTime",
                fieldName: "Arrival Time",
                fieldType: "time",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-checkInDate",
                fieldName: "Check In Date",
                fieldType: "date",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-departureDate",
                fieldName: "Departure Date",
                fieldType: "date",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-departureTime",
                fieldName: "Departure Time",
                fieldType: "time",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-checkOutDate",
                fieldName: "Check Out Date",
                fieldType: "date",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-numberOfDaysStay",
                fieldName: "Number of Days Stay",
                fieldType: "number",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-roomType",
                fieldName: "Room Type",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_roomingInformation-hotelConfirmationNumber",
                fieldName: "Hotel Confirmation Number",
                fieldType: "text",
                propertyType: "attendee",
            },
        ],
    },
    {
        _id: "travel",
        title: "Attendee Travel Fields",
        fields: [
            {
                _id: "_travelInformation-originCity",
                fieldName: "Origin City",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-originState",
                fieldName: "Origin State",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalCity",
                fieldName: "Arrival City",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalState",
                fieldName: "Arrival State",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalDate",
                fieldName: "Arrival Date",
                fieldType: "date",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalTime",
                fieldName: "Arrival Time",
                fieldType: "time",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalCarrier",
                fieldName: "Arrival Carrier",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalFlight",
                fieldName: "Arrival Flight",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalTicketed",
                fieldName: "Arrival Ticketed",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalClassOfService",
                fieldName: "Arrival Class of Service",
                fieldType: "text",
                propertyType: "attendee",
            },
            {
                _id: "_travelInformation-arrivalLocator",
                fieldName: "Arrival Locator",
                fieldType: "text",
                propertyType: "attendee",
            },
        ],
    },
    {
        _id: "special",
        title: "Special Function Fields",
        fields: [
            {
                _id: "_additionalAttendees",
                fieldName: "Additional Attendees",
                fieldType: "additionalAttendees",
                propertyType: "base",
                moduleConfiguration: {
                    label: "Guest",
                    maxAttendees: 2,
                    associatedGroup: null,
                    defaultStatus: "registered",
                    confirmationEmail: null,
                    fields: [
                        {
                            _id: "_firstName",
                            attendeeField: {
                                propertyType: "base",
                                propertyName: "firstName",
                            },
                            columnClass: "col-12",
                            description: "",
                            disabled: false,
                            id: "_attendeeFirstName",
                            label: "First Name",
                            objectClass: "xbaseInput",
                            options: [],
                            placeholder: "",
                            required: true,
                            style: "",
                            type: "text",
                            static: true,
                        },
                        {
                            _id: "_lastName",
                            attendeeField: { propertyType: "base", propertyName: "lastName" },
                            columnClass: "col-12",
                            description: "",
                            disabled: false,
                            id: "_attendeeLastName",
                            label: "Last Name",
                            objectClass: "xbaseInput",
                            options: [],
                            placeholder: "",
                            required: false,
                            style: "",
                            type: "text",
                            static: false,
                        },
                        {
                            _id: "_email",
                            attendeeField: { propertyType: "base", propertyName: "email" },
                            columnClass: "col-12",
                            description: "",
                            disabled: false,
                            id: "_attendeeEmail",
                            label: "Email",
                            objectClass: "xbaseInput",
                            options: [],
                            placeholder: "",
                            required: true,
                            style: "",
                            type: "email",
                            static: true,
                        },
                    ],
                },
            },
            {
                _id: "*notifierEmail",
                fieldName: "Notifier Email",
                fieldType: "notifierEmail",
                propertyType: "custom",
                moduleConfiguration: {
                    notificationEmail: null,
                },
            },
            {
                _id: "_medProLookup",
                fieldName: "MedPro Lookup",
                fieldType: "medProLookup",
                propertyType: "base",
                moduleConfiguration: {
                    medProID: false,
                    medProMasterID: false,
                    firstName: false,
                    lastName: false,
                    suffix: false,
                    title: false,
                    address: false,
                    licenseNumber: false,
                    licenseState: false,
                },
            },
            {
                _id: "_salesForceSearchContact",
                fieldName: "Salesforce Search Contact",
                fieldType: "salesForceSearchContact",
                propertyType: "base",
                moduleConfiguration: {
                    medProID: false,
                    medProMasterID: false,
                    firstName: false,
                    lastName: false,
                    suffix: false,
                    title: false,
                    address: false,
                    licenseNumber: false,
                    licenseState: false,
                },
            },
            {
                _id: "_salesForceSearchAccount",
                fieldName: "Salesforce Search Account",
                fieldType: "salesForceSearchAccount",
                propertyType: "base",
                moduleConfiguration: {
                    medProID: false,
                    medProMasterID: false,
                    firstName: false,
                    lastName: false,
                    suffix: false,
                    title: false,
                    address: false,
                    licenseNumber: false,
                    licenseState: false,
                },
            },
            {
                _id: "*groupSelection",
                fieldName: "Group Selection",
                fieldType: "groupSelection",
                propertyType: "custom",
                moduleConfiguration: {},
            },
        ],
    },
];

const pageAvailabilityOptions = [
    { value: true, label: "Public (Available to anyone)" },
    { value: false, label: "Private (Only for logged in users)" },
];

class RegistrationFlowSetup extends Component {
    constructor(props) {
        super(props);
        const keyedMetadata = [
            'organization.name',
            'event.name',
            'event.startDate',
            'event.startTime',
            'event.endDate',
            'event.endTime',
            'event.nameSlug',
            'event.timezone',
            'attendee.firstName',
            'attendee.lastName',
            'attendee.email',
            'attendee.phoneNumber',
            'attendee.title',
            'attendee.company',
            'attendee.textMessageOptIn',
            'attendee.dietaryPreference',
            'attendee.foodAllergies',
            'attendee.emergencyContactName',
            'attendee.emergencyContactPhoneNumber',
            'attendee.address',
            'attendee.address2',
            'attendee.city',
            'attendee.state',
            'attendee.zip',
            'attendee.country',
            'venue.name',
            'venue.city',
            'venue.state',
            'venue.address1',
            'venue.address2',
            'venue.postalCode',
            'venue.country'
        ];
        const keyedData = {
            organization: {
                name: 'Name',
                _defaultLabel: 'Organization'
            },
            event: {
                name: 'Name',
                startDate: 'Start Date',
                startTime: 'Start Time',
                endDate: 'End Date',
                endTime: 'End Time',
                nameSlug: 'Name Slug',
                timezone: 'Timezone',
                _defaultLabel: 'Event'
            },
            attendee: {
                firstName: 'First Name',
                lastName: 'Last Name',
                email: 'Email',
                phoneNumber: 'Phone Number',
                title: 'Title',
                company: 'Company',
                textMessageOptIn: 'Text Message Opt In',
                dietaryPreference: 'Dietary Preference',
                foodAllergies: 'Food Allergies',
                emergencyContactName: 'Emergency Contact Name',
                emergencyContactPhoneNumber: 'Emergency Contact PhoneNumber',
                address: 'Address',
                address2: 'Address 2',
                city: 'City',
                state: 'State',
                zip: 'Zip',
                country: 'Country',
                _defaultLabel: 'Attendee'
            },
            venue: {
                name: 'Name',
                city: 'City',
                state: 'State',
                address1: 'Address',
                address2: 'Address 2',
                postalCode: 'Postal Code',
                country: 'Country',
                _defaultLabel: 'Venue'
            }
        };

        this.state = {
            loading: true,
            selectedSection: "setup",
            editing: false,
            error: null,
            registrationFlowConfiguration: {},
            baseRegistrationFlowConfiguration: {},
            tabs: [
                { title: "Setup", id: "setup" },
                { title: "Form Design", id: "design" },
                { title: "Confirmation", id: "confirmation" },
                { title: "Publish", id: "deploy" },
            ],
            groupNames: [
                // Add safe check for the entire chain
                ...(props.program?.eventDefaults?.groups ? props.program.eventDefaults.groups.map((group) => {
                    return { value: group._id, label: group.name, color: "#00B8D9" };
                }) : []),
            ],
            addTicketModalOpen: false,
            formBuilderModalOpen: false,
            pageBuilderModalOpen: false,
            emailBuilderModalOpen: false,
            emailTemplateModalOpen: false,
            pageTemplates: [],
            editCount: 0,
            editedForm: {},
            editingRegistrationForm: false,
            customBaseFields: [],
            keyedMetadata: {},
            keyedData: {},
            templates: [],
            platformTemplates: [],
            defaultSenderEmail: null,
            defaultSenderName: null,
            linkCopied: false,
            deleteFlowModalOpen: false,
            keyedMetadata: keyedMetadata,
            keyedData: keyedData,
            integrations: {},
        };
    }

    async componentDidMount() {
        const { orgId, programId, organization, program } = this.props;
        const flowId = this.props.match.params.flowId;
        const orgIntegrations = {};
        organization.integrations.forEach((integration) => {
            orgIntegrations[integration.identifier] = integration;
        });

        await API()
            .get(`Organizations/${orgId}/getTemplates?templateType=registration`)
            .then((res) => {
                let platformTemplates = [];

                if (res.data) {
                    platformTemplates = res.data.map((template) => {
                        return {
                            value: template._id,
                            label: template.title,
                            color: "#00B8D9",
                        };
                    });
                }
                this.setState({ pageTemplates: platformTemplates });
            });

        // Get the flow data from the API call
        API()
            .get(`Organizations/${orgId}/programs/${programId}`)
            .then((res) => {
                if (res.data && res.data.eventDefaults && res.data.eventDefaults.registrationFlows) {
                    // Find the specific flow by matching the flowId
                    const flow = res.data.eventDefaults.registrationFlows.find(f => f._id === flowId);
                    if (flow) {
                        // Map the registration group to include the full group object
                        const mappedFlow = {
                            ...flow,
                            registrationGroup: flow.registrationGroup ?
                                res.data.eventDefaults.groups.find((group) => group._id === flow.registrationGroup) : null,
                        };

                        this.processFlowData(mappedFlow, orgIntegrations);
                    } else {
                        console.error('Flow not found with ID:', flowId);
                        this.setState({ loading: false });
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching program data:', error);
                this.setState({ loading: false });
            });

        API().get(`/Organizations/${orgId}/getPlatformEmailTemplates`).then((res) => {
            if (res.data) {
                this.setState({
                    platformTemplates: res.data.platformTemplates,
                    loading: false
                });
            }
        }
        );
    }

    // Add this new method to process the flow data
    processFlowData = (flow, orgIntegrations) => {
        const { program } = this.props;

        const processedFlow = {
            ...flow,
            registrationGroup: flow.registrationGroup ? this.state.groupNames.find(
                (group) => group.value === flow.registrationGroup._id
            ) : null,
        };

        const baseFlow = JSON.parse(JSON.stringify(processedFlow));
        const editedForm = program?.eventDefaults?.forms?.find(
            form => form._id === flow.form
        ) || {};

        let tabs = this.state.tabs;

        if (baseFlow.ticketingEnabled) {
            //add tickets tab in between setup and design
            const designIndex = tabs.findIndex((tab) => tab.id === "design");
            if (designIndex !== -1) {
                tabs.splice(designIndex, 0, { title: "Tickets", id: "tickets" });
            }
        }

        if (orgIntegrations && orgIntegrations.salesforce) {
            // add integrations tab before publish tab
            if (!tabs.find((tab) => tab.id === "integrations")) {
                const publishIndex = tabs.findIndex((tab) => tab.id === "deploy");
                if (publishIndex !== -1) {
                    tabs.splice(publishIndex, 0, { title: "Integrations", id: "integrations" });
                }
            }
            if (!program.integrations?.salesforce?.campaignName) {
                processedFlow.salesforceLeadEnabled = false;
                baseFlow.salesforceLeadEnabled = false;
            }
        }
        this.setState({
            registrationFlowConfiguration: processedFlow,
            baseRegistrationFlowConfiguration: baseFlow,
            loading: false,
            editedForm: editedForm,
            tabs: tabs,
            integrations: orgIntegrations,
        });
    }
    handleNameChange = (e) => {
        const originalGroups = this.state.groupNames.filter(group => !group.new);
        
        if (!e || e.trim() === '') {
            this.setState({
                groupNames: originalGroups
            });
            return;
        }
        
        const filteredGroupNames = originalGroups.filter((group) =>
            group.label.toLowerCase().includes(e.toLowerCase())
        );
        
        const exactMatch = originalGroups.some(group => 
            group.label.toLowerCase() === e.toLowerCase()
        );
        
        let updatedGroups = [...filteredGroupNames];
        
        if (!exactMatch && e.trim().length > 0) {
            updatedGroups.push({
                label: "New group: " + e,
                color: "#00B8D9",
                new: true
            });
        }
        this.setState({
            groupNames: updatedGroups
        });
    };

    handleGroupChosen = (e) => {
        const { registrationFlowConfiguration } = this.state;

        if (e.new) {
            this.setState({
                registrationFlowConfiguration: {
                    ...registrationFlowConfiguration,
                    registrationGroup: { ...e, label: e.label.split("New group: ")[1] },
                    newGroupChosen: true,
                },
                editing: true,
            });
        } else {
            this.setState({
                registrationFlowConfiguration: {
                    ...registrationFlowConfiguration,
                    registrationGroup: e,
                    newGroupChosen: false,
                },
                editing: true,
            });
        }
    };

    saveRegistrationFlowConfiguration = () => {
        const { orgId, flowId, eventId } = this.props;
        const { registrationFlowConfiguration } = this.state;

        const payload = {
            ...registrationFlowConfiguration,
        };

        if (registrationFlowConfiguration.newGroupChosen) {
            payload.registrationGroupName =
                registrationFlowConfiguration.registrationGroup.label;
            delete payload.registrationGroup;
        } else {
            payload.registrationGroup =
                registrationFlowConfiguration.registrationGroup
                    ? registrationFlowConfiguration.registrationGroup.value
                    : null;
        }


        const data = {
            request: 'updateDefaultEventRegistrationFlow',
            registrationFlow: payload
        }
        try {
            const response = API().patch(`Organizations/${orgId}/programs/${this.props.program._id}`, data);
            response.then((res) => {
                if (res.data) {
                    this.props.updateProgramGroups(res.data.groups)
                    this.setState({
                        editing: false,
                        response: res.data,
                    }, () => {
                        this.props.updateFlow(this.state.registrationFlowConfiguration);
                    });
                }
            }).catch((error) => {
                console.error("Patch error:", error);
            });
        } catch (error) {
            console.error("Error in try block:", error);
        }

        if (payload) {
            const tabs = this.state.tabs;


            if (payload.ticketingEnabled && !tabs.find((tab) => tab.id === "tickets")) {
                //add tickets tab in between setup and design
                const designIndex = tabs.findIndex((tab) => tab.id === "design");
                if (designIndex !== -1) {
                    tabs.splice(designIndex, 0, { title: "Tickets", id: "tickets" });
                }

                // Add payments tab if ticketing is enabled and page is published
                if (payload.page.published && !tabs.find((tab) => tab.id === "payments")) {
                    tabs.push({ title: "Payments", id: "payments" });
                }
            } else if (!payload.ticketingEnabled && tabs.find((tab) => tab.id === "tickets")) {
                const ticketsIndex = tabs.findIndex((tab) => tab.id === "tickets");
                if (ticketsIndex !== -1) {
                    tabs.splice(ticketsIndex, 1);
                }

                // Remove payments tab if ticketing is disabled
                const paymentsIndex = tabs.findIndex((tab) => tab.id === "payments");
                if (paymentsIndex !== -1) {
                    tabs.splice(paymentsIndex, 1);
                }
            }

            let registrationGroupObj = null;
            if (payload.registrationGroup) {
                registrationGroupObj = this.state.groupNames.find(
                    (group) => group.value === payload.registrationGroup
                );
            } else if (registrationFlowConfiguration.newGroupChosen) {
                registrationGroupObj = registrationFlowConfiguration.registrationGroup;
            }

            this.setState({
                editing: false,
                tabs: tabs,
                registrationFlowConfiguration: {
                    ...payload,
                    registrationGroup: registrationGroupObj || null,
                },
                baseRegistrationFlowConfiguration: {
                    ...payload,
                    registrationGroup: registrationGroupObj || null,
                }
            });
        }
    };


    updateFlowTickets = () => {
        // send back the updated tickets to the parent component in the formatted reg flow
        const tickets = this.state.registrationFlowConfiguration.tickets;
        const updatedFlow = {
            ...this.state.registrationFlowConfiguration,
            tickets: tickets,
            registrationGroup: this.props.program.eventDefaults.groups.find(
                (group) =>
                    group._id ===
                    this.state.registrationFlowConfiguration.registrationGroup.value
            ),
        };
        this.props.updateFlow(updatedFlow);
    };

    saveRegistrationForm = async () => {
        const { orgId } = this.props;
        const { registrationFlowConfiguration } = this.state;
        const { submissions, confirmationEmail, ...rest } = registrationFlowConfiguration.form;
        const payload = { ...rest };

        if (registrationFlowConfiguration.form.confirmationEmail?.templateId) {
            try {
                const data = {
                    request: 'createEmailTemplate',
                    registrationFlow: {
                        formid: registrationFlowConfiguration.form._id,
                        emailTemplateId: registrationFlowConfiguration.form.confirmationEmail.templateId,
                    }
                };
                const response = await API().patch(`Organizations/${orgId}/programs/${this.props.program._id}`, data);
                if (response.data) {
                    const program = await API().get(`Organizations/${orgId}/programs/${this.props.program._id}`);
                    const updatedFlow = program.data.eventDefaults.registrationFlows.find(
                        response => response._id === registrationFlowConfiguration._id
                    );
                    let confirmationEmail = updatedFlow.form.confirmationEmail;
                    this.setState(prevState => ({
                        registrationFlowConfiguration: {
                            ...prevState.registrationFlowConfiguration,
                            form: {
                                ...prevState.registrationFlowConfiguration.form,
                                confirmationEmail: confirmationEmail,
                            },
                        },
                        baseRegistrationFlowConfiguration: {
                            ...prevState.baseRegistrationFlowConfiguration,
                            form: {
                                ...prevState.baseRegistrationFlowConfiguration.form,
                                confirmationEmail: confirmationEmail,
                            },
                        },
                        editCount: prevState.editCount + 1,
                    }));
                }
                return;
            } catch (error) {
                console.error("API Error:", error);
                return;
            }
        }



        const data = {
            request: 'updateDefaultEventForm',
            formId: payload._id,
            formTemplateDetails: payload
        };

        try {
            const response = await API().patch(`Organizations/${orgId}/programs/${this.props.program._id}`, data);
            if (response.data) {
                let updatedForm = payload;
                if (registrationFlowConfiguration.form.confirmationEmail) {
                    updatedForm.confirmationEmail = registrationFlowConfiguration.form.confirmationEmail;
                }

                this.setState({
                    registrationFlowConfiguration: {
                        ...registrationFlowConfiguration,
                        form: updatedForm,
                    },
                    baseRegistrationFlowConfiguration: {
                        ...this.state.baseRegistrationFlowConfiguration,
                        form: updatedForm,
                    },
                    editingRegistrationForm: false,
                });
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    updatePage = async (updatedPage) => {
        this.setState({
            registrationFlowConfiguration: {
                ...this.state.registrationFlowConfiguration,
                page: updatedPage,
            },
            baseRegistrationFlowConfiguration: {
                ...this.state.baseRegistrationFlowConfiguration,
                page: updatedPage,
            },
        });
    };

    updateTemplateHtml = async (emailTemplate) => {
        const { orgId, programId } = this.props;
        const { registrationFlowConfiguration } = this.state;

        const data = {
            request: 'updateEmailTemplateInRegistrationFlow',
            registrationFlow: {
                templateId: registrationFlowConfiguration.form.confirmationEmail._id,
                updateData: {
                    name: emailTemplate.name,
                    html: emailTemplate.html,
                    parameters: emailTemplate.parameters,
                    emailStyles: emailTemplate.emailStyles,
                    emailComponents: emailTemplate.emailComponents,
                    codeOnly: emailTemplate.codeOnly,
                }
            }
        };
        try {
            const response = await API().patch(`Organizations/${orgId}/programs/${programId}`, data);
            if (response.data) {
                this.setState({
                    registrationFlowConfiguration: {
                        ...registrationFlowConfiguration,
                        form: {
                            ...registrationFlowConfiguration.form,
                            confirmationEmail: response.data,
                        },
                    },
                    baseRegistrationFlowConfiguration: {
                        ...this.state.baseRegistrationFlowConfiguration,
                        form: {
                            ...this.state.baseRegistrationFlowConfiguration.form,
                            confirmationEmail: response.data,
                        },
                    },
                });
            }
        } catch (error) {
            console.error("Error updating email template:", error);
        }
    };

    cancelEdit = () => {
        const { baseRegistrationFlowConfiguration } = this.state;
        this.setState({
            registrationFlowConfiguration: {
                ...baseRegistrationFlowConfiguration,
                registrationGroup: baseRegistrationFlowConfiguration.registrationGroup
                    ? this.state.groupNames.find(
                        (group) =>
                            group.value ===
                            baseRegistrationFlowConfiguration.registrationGroup.value
                    )
                    : null,
            },
            editing: false,
        });
    };

    handleCopyRegLink = () => {
        const { registrationFlowConfiguration } = this.state;
        const link = this.props.organization.hostname
            ? `https://${this.props.organization.hostname}/Eventname/${registrationFlowConfiguration.page.pathSlug}`
            : `https://${this.props.organization.identifier}.simple.events/Eventname/${registrationFlowConfiguration.page.pathSlug}`;
        navigator.clipboard.writeText(link).then(() => {
            this.setState({ linkCopied: true });
            setTimeout(() => {
                this.setState({ linkCopied: false });
            }, 2000);
        });
    };

    onDragTicketsEnd = (result) => {
        //reorder tickets
        const { registrationFlowConfiguration } = this.state;
        const items = Array.from(registrationFlowConfiguration.tickets);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        this.setState({
            registrationFlowConfiguration: {
                ...registrationFlowConfiguration,
                tickets: items,
            },
            editing: true,
        });
    };

    renderSection = () => {
        const {
            selectedSection,
            registrationFlowConfiguration,
            groupNames,
            pageBuilderModalOpen,
            editCount,
            emailBuilderModalOpen,
            editing,
            baseRegistrationFlowConfiguration,
        } = this.state;
        const { orgId, programId, organization, program } = this.props;
        const registrationGroup =
            registrationFlowConfiguration.registrationGroup &&
            this.props.program.eventDefaults.groups.find(
                (group) =>
                    group._id ===
                    registrationFlowConfiguration.registrationGroup._id
            );
        switch (selectedSection) {
            case "setup":
                return (
                    <div className="blocksContainer">
                        <div className="flex w-100 gap20">
                            <div className="sectionBlock contained-h">
                                <h2 className="blockHeader">General Flow Details</h2>
                                <InputField
                                    label="Registration Flow Name"
                                    required={true}
                                    value={registrationFlowConfiguration.name}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                name: e.target.value,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <div className="flex gap10">
                                    <InputField
                                        label="Days before event start"
                                        classes={"w-100"}
                                        type="number"
                                        required
                                        name="startOffsetDays"
                                        placeholder="Enter start date"
                                        value={registrationFlowConfiguration.startOffsetDays}
                                        onChange={(e) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    startOffsetDays: e.target.value,
                                                },
                                                editing: true,
                                            });
                                        }}
                                    />
                                    <TimeField
                                        label="Start Time"
                                        classes={"w-100"}
                                        value={registrationFlowConfiguration.startTime}
                                        type="time"
                                        required
                                        inputIcon={<i className="lar la-clock" />}
                                        name="startTime"
                                        placeholder="Enter start time"
                                        onChange={(e) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    startTime: e,
                                                },
                                                editing: true,
                                            });
                                        }}
                                    />
                                </div>
                                <div className="flex gap10">
                                    <InputField
                                        label="Days after event start"
                                        classes={"w-100"}
                                        type="number"
                                        required
                                        name="endOffsetDays"
                                        placeholder="Days after event start"
                                        value={registrationFlowConfiguration.endOffsetDays}
                                        onChange={(e) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    endOffsetDays: e.target.value,
                                                },
                                                editing: true,
                                            });
                                        }}
                                        min="0"
                                    />
                                    <TimeField
                                        label="End Time"
                                        classes={"w-100"}
                                        value={registrationFlowConfiguration.endTime}
                                        type="time"
                                        required
                                        inputIcon={<i className="lar la-clock" />}
                                        name="endTime"
                                        placeholder="Enter end time"
                                        onChange={(e) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    endTime: e,
                                                },
                                                editing: true,
                                            });
                                        }}
                                    />
                                </div>

                                <SelectField
                                    label="Availability"
                                    required={true}
                                    classes="w-100"
                                    information="Private pages will enable advance form configurations to logged in attendees."
                                    placeholder="Page availability"
                                    value={
                                        registrationFlowConfiguration.page.openToPublic
                                            ? pageAvailabilityOptions[0]
                                            : pageAvailabilityOptions[1]
                                    }
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                page: {
                                                    ...registrationFlowConfiguration.page,
                                                    openToPublic: e.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                    options={pageAvailabilityOptions}
                                />

                                <InputField
                                    subText={`https://${organization.hostname
                                        ? organization.hostname
                                        : organization.identifier + ".simple.events"
                                        }/eventName/${registrationFlowConfiguration.page.pathSlug
                                        }`}
                                    label="Page Web Address"
                                    required={true}
                                    placeholder="Unique slug for this page"
                                    value={registrationFlowConfiguration.page.pathSlug}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                page: {
                                                    ...registrationFlowConfiguration.page,
                                                    pathSlug: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <ToggleField
                                    label="Enable Paid Tickets"
                                    classes={"w-100"}
                                    checked={registrationFlowConfiguration.ticketingEnabled}
                                    icons={false}
                                    information="Enable ticketing if you wish to sell tickets for this flow."
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                ticketingEnabled: e.target.checked,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <SelectField
                                    label="Registration Group"
                                    classes={"w-100"}
                                    name="groupName"
                                    information="Select or create a group attendees that will be added to when they register in this flow."
                                    options={groupNames}
                                    required
                                    onChange={this.handleGroupChosen}
                                    onInputChange={this.handleNameChange}
                                    value={registrationFlowConfiguration.registrationGroup}
                                />

                                <ToggleField
                                    label="Enable Attendance Confirmation"
                                    checked={registrationFlowConfiguration.form.rsvpEnabled}
                                    icons={false}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    rsvpEnabled: e.target.checked,
                                                    denialEnabled: !e.target.checked ? false : registrationFlowConfiguration.form.denialEnabled,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />

                                {registrationFlowConfiguration.form.rsvpEnabled && <ToggleField
                                    label="Allow attendees to decline attendance"
                                    checked={registrationFlowConfiguration.form.denialEnabled}
                                    icons={false}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    denialEnabled: e.target.checked,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />}
                            </div>
                        </div>
                    </div>
                );
            case "tickets":
                return (
                    <div className="blocksContainer">
                        <div className="flex w-100 gap20">
                            <div className="sectionBlock contained-h">
                                <h2 className="blockHeader">Paid Ticketing Setup</h2>
                                <InputField
                                    label="Ticket Page Title"
                                    required={false}
                                    placeholder="Get your tickets"
                                    value={registrationFlowConfiguration.ticketPageTitle}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                ticketPageTitle: e.target.value,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <InputField
                                    label="Ticket Page Description"
                                    required={false}
                                    placeholder="Purchase tickets to attend this event."
                                    value={registrationFlowConfiguration.ticketPageDescription}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                ticketPageDescription: e.target.value,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <InputField
                                    label="Payment Screen Title"
                                    required={false}
                                    placeholder="Payment"
                                    value={registrationFlowConfiguration.paymentScreenTitle}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                paymentScreenTitle: e.target.value,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <InputField
                                    label="Payment Screen Description"
                                    required={false}
                                    placeholder="Enter payment information to complete your registration."
                                    value={registrationFlowConfiguration.paymentScreenDescription}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                paymentScreenDescription: e.target.value,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                            </div>
                            {registrationFlowConfiguration.ticketingEnabled && (
                                <div className="sectionBlock contained-h">
                                    <div className="flex aic jcsb mt-20">
                                        <div className="w-100">
                                            <h2 className="blockHeader m-0">Paid Tickets</h2>
                                            <p className="mb-0">
                                                Drag tickets to organize their order on the registration
                                                form
                                            </p>
                                        </div>
                                        <button
                                            className={`prim ${this.state.editing ? "disabled" : ""}`}
                                            onClick={() => {
                                                this.setState({ addTicketModalOpen: true });
                                            }}
                                            disabled={this.state.editing}
                                        >
                                            Add Ticket
                                        </button>
                                    </div>
                                    <div className="ticketsContainer mt-20">
                                        <DragDropContext onDragEnd={this.onDragTicketsEnd}>
                                            <Droppable droppableId="droppable">
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                        className="draggableTicketsContainer"
                                                    >
                                                        {registrationFlowConfiguration.tickets.map(
                                                            (ticket, index) => {
                                                                return (
                                                                    <Draggable
                                                                        key={ticket._id}
                                                                        draggableId={ticket._id}
                                                                        index={index}
                                                                    >
                                                                        {(provided, snapshot) => (
                                                                            <div
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                className={`draggableGridItem `}
                                                                                style={{
                                                                                    backgroundColor: snapshot.isDragging
                                                                                        ? "#f5f5f5"
                                                                                        : undefined,
                                                                                    ...provided.draggableProps.style,
                                                                                }}
                                                                            >
                                                                                <TicketItem
                                                                                    ticket={ticket}
                                                                                    draggable={true}
                                                                                    providedDrag={
                                                                                        provided.dragHandleProps
                                                                                    }
                                                                                    providedDrop={provided}
                                                                                    isDragging={snapshot.isDragging}
                                                                                    onEdit={() => {
                                                                                        this.setState({
                                                                                            editingTicket: ticket,
                                                                                            editTicketModalOpen: true,
                                                                                        });
                                                                                    }}
                                                                                    onDuplicate={() => {
                                                                                        this.setState({
                                                                                            duplicatingTicket: ticket,
                                                                                            duplicateTicketModalOpen: true,
                                                                                        });
                                                                                    }}
                                                                                    onDelete={() => {
                                                                                        this.setState({
                                                                                            deletingTicket: ticket,
                                                                                            deleteTicketModalOpen: true,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </Draggable>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                );
            case "design":
                return (
                    <div className="blocksContainer">
                        <div className="flex w-100 gap20">
                            <div className="sectionBlock contained-h">
                                <h2 className="blockHeader">Registration Form Details</h2>
                                <InputField
                                    label="Registration Not Yet Open Title"
                                    required={false}
                                    placeholder="Form not yet available"
                                    value={registrationFlowConfiguration.form.formNotOpenYetTitle}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    formNotOpenYetTitle: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />

                                <InputField
                                    label="Registration Not Yet Open Message"
                                    required={false}
                                    placeholder=""
                                    information="Will display opening date and time with or without message."
                                    value={registrationFlowConfiguration.form.formNotOpenYetMessage}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    formNotOpenYetMessage: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <InputField
                                    label="Registration Closed Title"
                                    required={false}
                                    placeholder="Form unavailable"
                                    value={registrationFlowConfiguration.form.formClosedTitle}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    formClosedTitle: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />

                                <InputField
                                    label="Registration Closed Message"
                                    required={false}
                                    placeholder="This form is not currently available, check back at a later time or reach out to support."
                                    value={registrationFlowConfiguration.form.formClosedMessage}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    formClosedMessage: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />

                                {registrationGroup && registrationGroup.maxCapacityEnabled && (
                                    <div>
                                        <InputField
                                            label="Registration Group Max Capacity Reached Title"
                                            required={false}
                                            placeholder="Registration is at capacity"
                                            value={registrationFlowConfiguration.form.maxCapTitle}
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            maxCapTitle: e.target.value,
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                        />
                                        <InputField
                                            label="Max Capacity Message"
                                            required={false}
                                            placeholder="This registration has reached capacity"
                                            value={
                                                registrationFlowConfiguration.form.maxCapacityMessage
                                            }
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            maxCapacityMessage: e.target.value,
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                        />
                                    </div>
                                )}

                                {registrationFlowConfiguration.form.rsvpEnabled && (<>
                                    <h2 className="blockHeader mt-20">Attendance Confirmation</h2>

                                    <InputField
                                        label="Submit Button Label"
                                        required={false}
                                        placeholder="Register for Event"
                                        value={registrationFlowConfiguration.form.rsvpLabel}
                                        onChange={(e) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    form: {
                                                        ...registrationFlowConfiguration.form,
                                                        rsvpLabel: e.target.value,
                                                    },
                                                },
                                                editing: true,
                                            });
                                        }}
                                    />
                                    {registrationFlowConfiguration.form.denialEnabled && (
                                        <div>
                                            <InputField
                                                label="Decline Button Label"
                                                required={false}
                                                placeholder="I am unable to attend"
                                                value={registrationFlowConfiguration.form.declineLabel}
                                                onChange={(e) => {
                                                    this.setState({
                                                        registrationFlowConfiguration: {
                                                            ...registrationFlowConfiguration,
                                                            form: {
                                                                ...registrationFlowConfiguration.form,
                                                                declineLabel: e.target.value,
                                                            },
                                                        },
                                                        editing: true,
                                                    });
                                                }}
                                            />

                                            <InputField
                                                label="Decline Page Title"
                                                required={false}
                                                placeholder="Sorry we missed you"
                                                value={registrationFlowConfiguration.form.declineTitle}
                                                onChange={(e) => {
                                                    this.setState({
                                                        registrationFlowConfiguration: {
                                                            ...registrationFlowConfiguration,
                                                            form: {
                                                                ...registrationFlowConfiguration.form,
                                                                declineTitle: e.target.value,
                                                            },
                                                        },
                                                        editing: true,
                                                    });
                                                }}
                                            />

                                            <RichTextEditor
                                                id="Decline_Page_Description"
                                                label="Decline Page Description"
                                                placeholder="Not attending"
                                                value={registrationFlowConfiguration.form.declineSubtitle}
                                                onChange={(e) => {
                                                    this.setState({
                                                        registrationFlowConfiguration: {
                                                            ...registrationFlowConfiguration,
                                                            form: {
                                                                ...registrationFlowConfiguration.form,
                                                                declineSubtitle: e,
                                                            },
                                                        },
                                                        editing: true,
                                                    });
                                                }}
                                                customFields={this.state.customFields}
                                            />

                                            <ToggleField
                                                label="Enable Decline Options"
                                                checked={
                                                    registrationFlowConfiguration.form.enableDeclineOptions
                                                }
                                                icons={false}
                                                onChange={(e) => {
                                                    this.setState({
                                                        registrationFlowConfiguration: {
                                                            ...registrationFlowConfiguration,
                                                            form: {
                                                                ...registrationFlowConfiguration.form,
                                                                enableDeclineOptions: e.target.checked,
                                                            },
                                                        },
                                                        editing: true,
                                                    });
                                                }}
                                            />

                                            {registrationFlowConfiguration.form
                                                .enableDeclineOptions && (
                                                    <div className="pb-20">
                                                        <div className="formFieldLabel">Decline Options</div>
                                                        {registrationFlowConfiguration.form.declineOptions.map(
                                                            (option, index) => {
                                                                return (
                                                                    <div className="flex-ac">
                                                                        <InputField
                                                                            label="Item"
                                                                            required={false}
                                                                            placeholder="Not attending"
                                                                            value={option}
                                                                            onChange={(e) => {
                                                                                registrationFlowConfiguration.form.declineOptions[
                                                                                    index
                                                                                ] = e.target.value;
                                                                                this.setState({
                                                                                    registrationFlowConfiguration,
                                                                                    editing: true,
                                                                                });
                                                                            }}
                                                                        />
                                                                        <i
                                                                            className="las la-times ml-10"
                                                                            onClick={() => {
                                                                                registrationFlowConfiguration.form.declineOptions.splice(
                                                                                    index,
                                                                                    1
                                                                                );
                                                                                this.setState({
                                                                                    registrationFlowConfiguration,
                                                                                    editing: true,
                                                                                });
                                                                            }}
                                                                        ></i>
                                                                    </div>
                                                                );
                                                            }
                                                        )}

                                                        <div
                                                            className="c-pointer flex jcc"
                                                            onClick={() => {
                                                                registrationFlowConfiguration.form.declineOptions.push(
                                                                    ""
                                                                );
                                                                this.setState({
                                                                    registrationFlowConfiguration,
                                                                    editing: true,
                                                                });
                                                            }}
                                                        >
                                                            + Add Decline Options
                                                        </div>
                                                    </div>
                                                )}

                                            {registrationFlowConfiguration.form
                                                .enableDeclineOptions && (
                                                    <ToggleField
                                                        label="Require Decline Options"
                                                        checked={
                                                            registrationFlowConfiguration.form
                                                                .requireDeclineOptions
                                                        }
                                                        icons={false}
                                                        onChange={(e) => {
                                                            this.setState({
                                                                registrationFlowConfiguration: {
                                                                    ...registrationFlowConfiguration,
                                                                    form: {
                                                                        ...registrationFlowConfiguration.form,
                                                                        requireDeclineOptions: e.target.checked,
                                                                    },
                                                                },
                                                                editing: true,
                                                            });
                                                        }}
                                                    />
                                                )}

                                            <ToggleField
                                                label="Include Decline Comment"
                                                checked={
                                                    registrationFlowConfiguration.form.enableDeclineComment
                                                }
                                                icons={false}
                                                onChange={(e) => {
                                                    this.setState({
                                                        registrationFlowConfiguration: {
                                                            ...registrationFlowConfiguration,
                                                            form: {
                                                                ...registrationFlowConfiguration.form,
                                                                enableDeclineComment: e.target.checked,
                                                            },
                                                        },
                                                        editing: true,
                                                    });
                                                }}
                                            />

                                            {registrationFlowConfiguration.form
                                                .enableDeclineComment && (
                                                    <ToggleField
                                                        label="Require Decline Comment"
                                                        checked={
                                                            registrationFlowConfiguration.form.requireComment
                                                        }
                                                        icons={false}
                                                        onChange={(e) => {
                                                            this.setState({
                                                                registrationFlowConfiguration: {
                                                                    ...registrationFlowConfiguration,
                                                                    form: {
                                                                        ...registrationFlowConfiguration.form,
                                                                        requireComment: e.target.checked,
                                                                    },
                                                                },
                                                                editing: true,
                                                            });
                                                        }}
                                                    />
                                                )}
                                        </div>
                                    )}
                                </>)}
                            </div>
                            <div className="sectionBlock  emailDesignPreview mt-20 ">
                                <div
                                    style={{
                                        maxWidth: "calc(100% - 15px)",
                                        minWidth: "calc(100% - 700px)",
                                    }}
                                    className="cardDetailsContainerPages containerTitle mb-20"
                                >
                                    <div className="w-100">
                                        <h2 className="blockHeader m-0">
                                            Registration Page Preview
                                        </h2>
                                        <p>Registration page as attendees will see</p>
                                    </div>
                                    <div className="flex aic gap10">
                                        <button
                                            className={`neu ${editing ? " disabled" : ""}`}
                                            disabled={editing}
                                            onClick={() => {
                                                this.setState({ pageBuilderModalOpen: true });
                                            }}
                                        >
                                            Edit Design
                                        </button>
                                        <button
                                            className={`neu prim ${editing ? " disabled" : ""}`}
                                            disabled={editing}
                                            onClick={() => {
                                                this.setState({
                                                    formBuilderModalOpen: true,
                                                    editingRegistrationForm: false,
                                                });
                                            }}
                                        >
                                            Edit Form
                                        </button>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        maxWidth: "calc(100% - 15px)",
                                        minWidth: "calc(100% - 700px)",
                                        height: 500,
                                    }}
                                >
                                    <div className="emailPreview eFrame pages flex-ac preview">
                                        {!pageBuilderModalOpen && (
                                            <PagePreviewFrame
                                                ENV={ENV}
                                                renderURL={`Organizations/${orgId}/programs/${programId}/render/${registrationFlowConfiguration.page._id}/`}
                                                preview={true}
                                                pageProperties={registrationFlowConfiguration.page}
                                                focusedComponent={""}
                                                simulatedUser={{}}
                                                simulatedSession={{ value: false }}
                                                renderOnly={true}
                                                editing={this.state.editCount}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case "confirmation":
                return (
                    <div className="blocksContainer">
                        <div className="flex w-100 gap20">
                            <div className="sectionBlock contained-h">
                                <h2 className="blockHeader">Submission Confirmation Details</h2>
                                <ToggleField
                                    label="Enable a review page before form submission"
                                    checked={
                                        registrationFlowConfiguration.form.enableSubmissionReview
                                    }
                                    icons={false}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    enableSubmissionReview: e.target.checked,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />

                                {registrationFlowConfiguration.form.enableSubmissionReview && (
                                    <div>
                                        <InputField
                                            label="Review Page Title"
                                            required={false}
                                            placeholder="Please Review"
                                            value={
                                                registrationFlowConfiguration.form.submissionReviewTitle
                                            }
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            submissionReviewTitle: e.target.value,
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                        />
                                        {/* Update */}
                                        <RichTextEditor
                                            id="Review_Page_Description"
                                            label="Review Page Description"
                                            placeholder="Look over your questions and go back if you need to edit."
                                            value={
                                                registrationFlowConfiguration.form
                                                    .submissionReviewSubtitle
                                            }
                                            onChange={(e) => {
                                                this.setState({
                                                    registrationFlowConfiguration: {
                                                        ...registrationFlowConfiguration,
                                                        form: {
                                                            ...registrationFlowConfiguration.form,
                                                            submissionReviewSubtitle: e,
                                                        },
                                                    },
                                                    editing: true,
                                                });
                                            }}
                                            customFields={this.state.customFields}
                                        />
                                    </div>
                                )}

                                <InputField
                                    label="Submission Success Title"
                                    required={false}
                                    placeholder="Form Submitted"
                                    value={registrationFlowConfiguration.form.successTitle}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    successTitle: e.target.value,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                                <RichTextEditor
                                    id="Confirmation_Page_Description"
                                    label="Submission Success Description"
                                    placeholder="We have received your information"
                                    value={registrationFlowConfiguration.form.successSubtitle}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    successSubtitle: e,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                    customFields={this.state.customFields}
                                />

                                <ToggleField
                                    label="Send Confirmation Email"
                                    checked={
                                        registrationFlowConfiguration.form.confirmationEmailEnabled
                                    }
                                    icons={false}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                form: {
                                                    ...registrationFlowConfiguration.form,
                                                    confirmationEmailEnabled: e.target.checked,
                                                },
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                            </div>

                            {registrationFlowConfiguration.form.confirmationEmailEnabled && (
                                <div className="sectionBlock emailDesignPreview mt-20 ">
                                    <div
                                        style={{
                                            maxWidth: "calc(100% - 15px)",
                                            minWidth: "calc(100% - 700px)",
                                        }}
                                        className="cardDetailsContainerPages containerTitle mb-20"
                                    >
                                        <div className="w-100">
                                            <h2 className="blockHeader m-0">
                                                Confirmation Email Preview
                                            </h2>
                                            <p>
                                                Preview of confirmation email as attendees will see.
                                            </p>
                                        </div>
                                        <div className="flex aic gap10">
                                            {registrationFlowConfiguration.form.confirmationEmail ? (
                                                <button
                                                    className={`neu prim ${editing ? " disabled" : ""}`}
                                                    onClick={() => {
                                                        this.setState({ emailBuilderModalOpen: true });
                                                    }}
                                                >
                                                    Edit Design
                                                </button>
                                            ) : (
                                                <button
                                                    className={`neu prim ${editing ? " disabled" : ""}`}
                                                    disabled={editing}
                                                    onClick={() => {
                                                        this.setState({ emailTemplateModalOpen: true });
                                                    }}
                                                >
                                                    Choose Design
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    {registrationFlowConfiguration.form.confirmationEmail ? (

                                        <div
                                            style={{
                                                maxWidth: "calc(100% - 15px)",
                                                minWidth: "calc(100% - 700px)",
                                                height: 500,
                                            }}
                                        >
                                            <div className="emailPreview eFrame pages flex-ac preview">
                                                {!emailBuilderModalOpen && (
                                                    <IFrame.Form
                                                        id="builderPreviewFrameTemplate"
                                                        className="emailPreviewWindow Frame"
                                                        key={`template-${this.state.editCount}`}
                                                        style={{
                                                            pointerEvents: "none",
                                                            transform: "scale(0.99)",
                                                        }}
                                                        name="PreviewFrameTemp"
                                                        config={{
                                                            url: `${ENV}Organizations/${orgId}/emailrenderer?preview=true`,
                                                            method: "post",
                                                            data: registrationFlowConfiguration.form.confirmationEmail,
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="explainerBox">
                                                <i
                                                    className="las la-info-circle"
                                                    style={{ fontSize: 50 }}
                                                ></i>
                                                <div>
                                                    <h2>Set up a confirmation email</h2>
                                                    <p>
                                                        Choose a template for your confirmation email or
                                                        create one from scratch to get started.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                );
            /*   case "submissions":
                  return (
                      <Submissions
                          containsTickets={baseRegistrationFlowConfiguration.ticketingEnabled}
                          event={event}
                          editedForm={registrationFlowConfiguration.form}
                          form={baseRegistrationFlowConfiguration.form}
                          toggleSubmissionEditing={() => { }}
                          disableCheck={true}
                      />
                  ); */

            case "deploy":
                const setupWarnings = [];
                const ticketWarnings = [];
                const designWarnings = [];
                const confirmationWarnings = [];

                // Check setup section requirements
                if (!baseRegistrationFlowConfiguration.name ||
                    baseRegistrationFlowConfiguration.name.trim() === '') {
                    setupWarnings.push("Registration Flow Name is missing");
                }
                if (!baseRegistrationFlowConfiguration.startOffsetDays) {
                    setupWarnings.push("Start Date is missing");
                }
                if (!baseRegistrationFlowConfiguration.startTime) {
                    setupWarnings.push("Start Time is missing");
                }
                if (!baseRegistrationFlowConfiguration.endOffsetDays) {
                    setupWarnings.push("End Date is missing");
                }
                if (!baseRegistrationFlowConfiguration.endTime) {
                    setupWarnings.push("End Time is missing");
                }
                if (!baseRegistrationFlowConfiguration.page.pathSlug ||
                    baseRegistrationFlowConfiguration.page.pathSlug.trim() === '') {
                    setupWarnings.push("Page Web Address is missing");
                }
                if (!baseRegistrationFlowConfiguration.registrationGroup) {
                    setupWarnings.push("Registration Group is missing");
                }

                // Check tickets section requirements if ticketing is enabled
                let ticketingComplete = !baseRegistrationFlowConfiguration.ticketingEnabled;
                if (baseRegistrationFlowConfiguration.ticketingEnabled) {
                    if (baseRegistrationFlowConfiguration.tickets.length === 0) {
                        ticketWarnings.push("At least one ticket must be added");
                    }
                    if (!baseRegistrationFlowConfiguration.ticketPageTitle ||
                        baseRegistrationFlowConfiguration.ticketPageTitle.trim() === '') {
                        ticketWarnings.push("Ticket Page Title is missing");
                    }
                    if (!baseRegistrationFlowConfiguration.ticketPageDescription ||
                        baseRegistrationFlowConfiguration.ticketPageDescription.trim() === '') {
                        ticketWarnings.push("Ticket Page Description is missing");
                    }
                    if (!baseRegistrationFlowConfiguration.paymentScreenTitle ||
                        baseRegistrationFlowConfiguration.paymentScreenTitle.trim() === '') {
                        ticketWarnings.push("Payment Screen Title is missing");
                    }
                    /* if (!baseRegistrationFlowConfiguration.paymentScreenDescription ||
                        baseRegistrationFlowConfiguration.paymentScreenDescription.trim() === '') {
                        ticketWarnings.push("Payment Screen Description is missing");
                    } */

                    ticketingComplete = ticketWarnings.length === 0;
                }

                // Check page design
                let pageDesignComplete = false;
                if (baseRegistrationFlowConfiguration.page?.partials?.find(partial =>
                    partial.file === 'v2/form' &&
                    partial.parameters?.find(param => param.key === 'linkedForm' && param.value !== '')
                )) {
                    pageDesignComplete = true;
                } else {
                    designWarnings.push("The registration form must be added to the page design");
                }

                // Check design section requirements
                if (!baseRegistrationFlowConfiguration.form.formClosedTitle ||
                    baseRegistrationFlowConfiguration.form.formClosedTitle.trim() === '') {
                    designWarnings.push("Registration Closed Title is missing");
                }
                if (!baseRegistrationFlowConfiguration.form.formClosedMessage ||
                    baseRegistrationFlowConfiguration.form.formClosedMessage.trim() === '') {
                    designWarnings.push("Registration Closed Message is missing");
                }

                if (registrationGroup && registrationGroup.maxCapacityEnabled) {
                    if (!baseRegistrationFlowConfiguration.form.maxCapTitle ||
                        baseRegistrationFlowConfiguration.form.maxCapTitle.trim() === '') {
                        designWarnings.push("Registration Group Max Capacity Reached Title is missing");
                    }
                    if (!baseRegistrationFlowConfiguration.form.maxCapacityMessage ||
                        baseRegistrationFlowConfiguration.form.maxCapacityMessage.trim() === '') {
                        designWarnings.push("Max Capacity Message is missing");
                    }
                }

                // Check registration form attendance confirmation settings
                if (baseRegistrationFlowConfiguration.form.rsvpEnabled) {
                    if (!baseRegistrationFlowConfiguration.form.rsvpLabel ||
                        baseRegistrationFlowConfiguration.form.rsvpLabel.trim() === '') {
                        designWarnings.push("Submit Button Label is missing when attendance confirmation is enabled");
                    }

                    // Check decline attendance settings
                    if (baseRegistrationFlowConfiguration.form.denialEnabled) {
                        if (!baseRegistrationFlowConfiguration.form.declineLabel ||
                            baseRegistrationFlowConfiguration.form.declineLabel.trim() === '') {
                            designWarnings.push("Decline Button Label is missing");
                        }
                        if (!baseRegistrationFlowConfiguration.form.declineTitle ||
                            baseRegistrationFlowConfiguration.form.declineTitle.trim() === '') {
                            designWarnings.push("Decline Page Title is missing");
                        }
                        if (!baseRegistrationFlowConfiguration.form.declineSubtitle) {
                            designWarnings.push("Decline Page Description is missing");
                        }

                        // Check decline options
                        if (baseRegistrationFlowConfiguration.form.enableDeclineOptions) {
                            if (baseRegistrationFlowConfiguration.form.declineOptions.length === 0) {
                                designWarnings.push("At least one Decline Option is missing");
                            } else if (baseRegistrationFlowConfiguration.form.declineOptions.some(
                                option => !option || option.trim() === '')) {
                                designWarnings.push("All Decline Options must have a value");
                            }
                        }
                    }
                }

                // Check registration form
                let registrationFormComplete = false;
                if (baseRegistrationFlowConfiguration.page.openToPublic) {
                    let hasEmail = false;
                    let hasFirstName = false;
                    let hasSFSearch = false;

                    baseRegistrationFlowConfiguration.form.pages.forEach(page => {
                        page.sections?.forEach(section => {
                            section.fields?.forEach(field => {
                                if (field.id === 'email') {
                                    hasEmail = true;
                                }
                                if (field.id === 'firstName') {
                                    hasFirstName = true;
                                }
                                if (field.type === 'salesForceSearchContact') {
                                    hasSFSearch = true;
                                }
                            });
                        });
                    });

                    registrationFormComplete = (hasEmail && hasFirstName) || hasSFSearch;

                    if (!hasEmail) {
                        designWarnings.push("The form must include an Email field");
                    }
                    if (!hasFirstName) {
                        designWarnings.push("The form must include a First Name field");
                    }
                } else {
                    const hasPages = baseRegistrationFlowConfiguration.form.pages.length > 0;
                    const hasSections = hasPages &&
                        baseRegistrationFlowConfiguration.form.pages[0].sections.length > 0;
                    const hasFields = hasSections &&
                        baseRegistrationFlowConfiguration.form.pages[0].sections[0].fields.length > 0;

                    registrationFormComplete = hasPages && hasSections && hasFields;

                    if (!hasPages) {
                        designWarnings.push("The form must have at least one page");
                    } else if (!hasSections) {
                        designWarnings.push("The form must have at least one section");
                    } else if (!hasFields) {
                        designWarnings.push("The form must have at least one field");
                    }
                }

                // Check confirmation section requirements
                if (baseRegistrationFlowConfiguration.form.enableSubmissionReview) {
                    if (!baseRegistrationFlowConfiguration.form.submissionReviewTitle ||
                        baseRegistrationFlowConfiguration.form.submissionReviewTitle.trim() === '') {
                        confirmationWarnings.push("Review Page Title is missing");
                    }
                    if (!baseRegistrationFlowConfiguration.form.submissionReviewSubtitle) {
                        confirmationWarnings.push("Review Page Description is missing");
                    }
                }

                if (!baseRegistrationFlowConfiguration.form.successTitle ||
                    baseRegistrationFlowConfiguration.form.successTitle.trim() === '') {
                    confirmationWarnings.push("Submission Success Title is missing");
                }
                if (!baseRegistrationFlowConfiguration.form.successSubtitle) {
                    confirmationWarnings.push("Submission Success Description is missing");
                }

                // Check confirmation email if enabled
                let confirmationEmailComplete = !baseRegistrationFlowConfiguration.form.confirmationEmailEnabled;
                if (baseRegistrationFlowConfiguration.form.confirmationEmailEnabled) {
                    if (!baseRegistrationFlowConfiguration.form.confirmationEmail) {
                        confirmationWarnings.push("Confirmation Email template needs to be selected");
                        confirmationEmailComplete = false;
                    } else {
                        confirmationEmailComplete = true;
                    }
                }

                if (baseRegistrationFlowConfiguration.page.openToPublic && !program.openToPublic) {
                    setupWarnings.push("Public registration is disabled for this event. Please enable it to allow public access to the registration page.");
                }

                // Determine overall completeness
                let configurationComplete = setupWarnings.length === 0 &&
                    designWarnings.length === 0 &&
                    confirmationWarnings.length === 0 &&
                    pageDesignComplete &&
                    registrationFormComplete &&
                    (baseRegistrationFlowConfiguration.ticketingEnabled ? ticketingComplete : true) &&
                    (baseRegistrationFlowConfiguration.form.confirmationEmailEnabled ? confirmationEmailComplete : true);


                return (
                    <div className="blocksContainer">
                        <div className="flex w-100">
                            <div className="sectionBlock mr-25 contained-h">
                                <div className="outlineCard">
                                    <p className="mb-20">
                                        Ready to launch this registration flow?<br />
                                        Just toggle the switch below to publish. Once your event is created from the program, it will be live.
                                    </p>
                                    <ToggleField
                                        label={<strong>Get started by publishing the page</strong>}
                                        icons={false}
                                        checked={registrationFlowConfiguration.page.published}
                                        disabled={!configurationComplete}
                                        onChange={(val) => {
                                            this.setState({
                                                registrationFlowConfiguration: {
                                                    ...registrationFlowConfiguration,
                                                    page: {
                                                        ...registrationFlowConfiguration.page,
                                                        published: val.target.checked,
                                                    },
                                                },
                                                editing: true,
                                            });
                                        }}
                                    />
                                    {!configurationComplete && (
                                        <div>
                                            <p className="mt-20 mb-20 modalErrorMessage small">
                                                It appears that the registration flow is incomplete.<br />
                                                Please finish setting up the unchecked items to publish the registration page:
                                            </p>
                                        </div>
                                    )}

                                    <div className={`mt-10 flex aic gap5 ${setupWarnings.length === 0 ? "blue" : "neu"}`}>
                                        {setupWarnings.length === 0 ?
                                            <i className="las la-check-circle"></i> :
                                            <i className="las la-times-circle"></i>}
                                        <p className={`small`}>General setup details</p>
                                    </div>
                                    {setupWarnings.length > 0 && (
                                        <div className="mt-5 ml-20">
                                            {setupWarnings.map((warning, index) => (
                                                <p key={index} className="small red mb-5">{warning}</p>
                                            ))}
                                        </div>
                                    )}

                                    {baseRegistrationFlowConfiguration.ticketingEnabled && (
                                        <>
                                            <div className={`mt-10 flex aic gap5 ${ticketingComplete ? "blue" : "neu"}`}>
                                                {ticketingComplete ?
                                                    <i className="las la-check-circle"></i> :
                                                    <i className="las la-times-circle"></i>}
                                                <p className={`small`}>Registration tickets</p>
                                            </div>
                                            {ticketWarnings.length > 0 && (
                                                <div className="mt-5 ml-20">
                                                    {ticketWarnings.map((warning, index) => (
                                                        <p key={index} className="small red mb-5">{warning}</p>
                                                    ))}
                                                </div>
                                            )}
                                        </>
                                    )}

                                    <div className={`mt-10 flex aic gap5 ${registrationFormComplete ? "blue" : "neu"}`}>
                                        {registrationFormComplete ?
                                            <i className="las la-check-circle"></i> :
                                            <i className="las la-times-circle"></i>}
                                        <p className={`small`}>Registration form</p>
                                    </div>

                                    <div className={`mt-10 flex aic gap5 ${pageDesignComplete ? "blue" : "neu"}`}>
                                        {pageDesignComplete ?
                                            <i className="las la-check-circle"></i> :
                                            <i className="las la-times-circle"></i>}
                                        <p className={`small`}>Registration page design</p>
                                    </div>

                                    <div className={`mt-10 flex aic gap5 ${designWarnings.length === 0 ? "blue" : "neu"}`}>
                                        {designWarnings.length === 0 ?
                                            <i className="las la-check-circle"></i> :
                                            <i className="las la-times-circle"></i>}
                                        <p className={`small`}>Form configuration</p>
                                    </div>
                                    {designWarnings.length > 0 && (
                                        <div className="mt-5 ml-20">
                                            {designWarnings.map((warning, index) => (
                                                <p key={index} className="small red mb-5">{warning}</p>
                                            ))}
                                        </div>
                                    )}

                                    <div className={`mt-10 flex aic gap5 ${confirmationWarnings.length === 0 ? "blue" : "neu"}`}>
                                        {confirmationWarnings.length === 0 ?
                                            <i className="las la-check-circle"></i> :
                                            <i className="las la-times-circle"></i>}
                                        <p className={`small`}>Confirmation details</p>
                                    </div>
                                    {confirmationWarnings.length > 0 && (
                                        <div className="mt-5 ml-20">
                                            {confirmationWarnings.map((warning, index) => (
                                                <p key={index} className="small red mb-5">{warning}</p>
                                            ))}
                                        </div>
                                    )}

                                    {/* {baseRegistrationFlowConfiguration.form.confirmationEmailEnabled && (
                                        <div className={`mt-10 flex aic gap5 ${confirmationEmailComplete ? "blue" : "neu"}`}>
                                            {confirmationEmailComplete ?
                                                <i className="las la-check-circle"></i> :
                                                <i className="las la-times-circle"></i>}
                                            <p className={`small`}>Confirmation email</p>
                                        </div>
                                    )} */}
                                </div>
                                {/*  {baseRegistrationFlowConfiguration.page.published && (
                                    <>
                                        <div>
                                            <h2 className="blockHeader">
                                                Include this link in an invitation email or share it directly with your attendees
                                            </h2>
                                            <div className={`flex aic gap10`}>
                                                <InputField
                                                    label="Registration page link"
                                                    required={false}
                                                    disabled={true}
                                                    value={this.props.organization.hostname ?
                                                        `https://${this.props.organization.hostname}/Eventname/${registrationFlowConfiguration.page.pathSlug}` :
                                                        `https://${this.props.organization.identifier}.simple.events/Eventname/${registrationFlowConfiguration.page.pathSlug}`
                                                    }
                                                    readOnly
                                                />
                                                <button
                                                    className={`neu ${this.state.linkCopied ? 'disabled' : ''}`}
                                                    onClick={this.handleCopyRegLink}
                                                >
                                                    {this.state.linkCopied ? 'Link Copied' : `Copy link`}
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                )} */}
                            </div>
                        </div>
                    </div>
                );
            /* case "payments":
                return (
                    <Payments
                        payments={baseRegistrationFlowConfiguration.payments || []}
                        name={baseRegistrationFlowConfiguration.name}
                    />
                ); */
            case "integrations":
                return (
                    <div className="blocksContainer">
                        <div className="flex w-100 gap20">
                            <div className="sectionBlock contained-h">
                                <h2 className="blockHeader">Salesforce Options</h2>
                                <ToggleField
                                    label="Submit registrant as lead in campaign"
                                    checked={registrationFlowConfiguration.salesforceLeadEnabled}
                                    icons={false}
                                    disabled={!program.eventDefaults.details.integrations.salesforce}
                                    information={!program.eventDefaults.details.integrations.salesforce ? "Please set up a Salesforce Campaign to enable this option." : false}
                                    onChange={(e) => {
                                        this.setState({
                                            registrationFlowConfiguration: {
                                                ...registrationFlowConfiguration,
                                                salesforceLeadEnabled: e.target.checked,
                                            },
                                            editing: true,
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>);
            default:
                return null;
        }
    };

    updateSelected = (_selectedIndex, selectedId) => {
        this.setState({ selectedSection: selectedId });
    };

    render() {
        const {
            baseRegistrationFlowConfiguration,
            loading,
            selectedSection,
            editing,
            tabs,
            addTicketModalOpen,
            registrationFlowConfiguration,
            editingRegistrationForm,
            formBuilderModalOpen,
            pageBuilderModalOpen,
            emailBuilderModalOpen,
            emailTemplateModalOpen,
            keyedMetadata,
            keyedData,
            deleteFlowModalOpen,
        } = this.state;

        const { program, orgId, programId } = this.props;
        if (!registrationFlowConfiguration || !baseRegistrationFlowConfiguration || Object.keys(registrationFlowConfiguration).length === 0) {
            return (
                <div className="sectionContainer">
                    <LoadingWizard text="Loading Registration Flow" loading={true} />
                </div>
            );
        }

        /*        scope="program"
                isOpen={pageBuilderModalOpen}
                toggle={() =>
                    this.setState({ pageBuilderModalOpen: !pageBuilderModalOpen })
                }
                lockForm={true}
                page={baseRegistrationFlowConfiguration.pageTemplate}
                editedPage={registrationFlowConfiguration.pageTemplate}
                updatePage={this.updatePage}
                cancelEdit={() => {
                    this.setState({
                        registrationFlowConfiguration: {
                            ...registrationFlowConfiguration,
                            pageTemplate: baseRegistrationFlowConfiguration.pageTemplate,
                        },
                        editing: false,
                    });
                }}
                program={this.props.program}
                orgId={orgId}
                programId={programId} */

        return (
            <div className="sectionContainer">
                <SectionHeader
                    enableLastLink={true}
                    title={baseRegistrationFlowConfiguration.name}
                    breadcrumbs={[
                        {
                            name: program.name,
                        },
                        {
                            name: "Registration Flows",
                        },
                    ]}
                    subActions={[
                        {
                            label: "Delete",
                            iconClass: "las la-trash red",
                            onClick: () => {
                                this.setState({ deleteFlowModalOpen: true });
                            },
                        },
                    ]}
                >
                    <TabsContainer
                        tabs={tabs}
                        updateSelected={this.updateSelected}
                        selectedIndex={tabs.findIndex((tab) => tab.id === selectedSection)}
                    />
                </SectionHeader>
                <div className="sectionBody">
                    {!loading && this.renderSection()}
                    {loading && (
                        <LoadingWizard text="Loading Registration Flow" loading={true} />
                    )}
                </div>
                <SectionFooter
                    updatedAt={baseRegistrationFlowConfiguration.updatedAt}
                    saveEdit={this.saveRegistrationFlowConfiguration}
                    cancelEdit={this.cancelEdit}
                    editing={editing}
                    lastEditedBy={""}
                />

                {addTicketModalOpen && (
                    <CreateRegistrationFlowTicketModal
                        isOpen={addTicketModalOpen}
                        toggle={() => {
                            this.setState({ addTicketModalOpen: false });
                        }}
                        flowId={this.props.flow._id}
                        orgId={this.props.orgId}
                        programId={this.props.programId}
                        updateFlow={(ticket) => {
                            this.setState(
                                (prevState) => ({
                                    registrationFlowConfiguration: {
                                        ...prevState.registrationFlowConfiguration,
                                        tickets: [
                                            ...prevState.registrationFlowConfiguration.tickets,
                                            ticket,
                                        ],
                                    },
                                    baseRegistrationFlowConfiguration: {
                                        ...prevState.baseRegistrationFlowConfiguration,
                                        tickets: [
                                            ...prevState.baseRegistrationFlowConfiguration.tickets,
                                            ticket,
                                        ],
                                    },
                                    addTicketModalOpen: false,
                                }),
                                this.updateFlowTickets
                            );
                        }}
                    />
                )}

                {formBuilderModalOpen && (
                    <FormBuilderModal
                        isOpen={formBuilderModalOpen}
                        editing={editingRegistrationForm}
                        toggle={() => {
                            this.setState({ formBuilderModalOpen: false });
                        }}
                        form={registrationFlowConfiguration.form}
                        editedForm={registrationFlowConfiguration.form}
                        fields={this.props.fields || []}
                        baseFieldList={[...baseFieldList, ...this.state.customBaseFields]}
                        links={{ get: `` }}
                        updateForm={(form) => {
                            this.setState({
                                registrationFlowConfiguration: {
                                    ...registrationFlowConfiguration,
                                    form: {
                                        ...registrationFlowConfiguration.form,
                                        ...form,
                                    },
                                },
                                editingRegistrationForm: true,
                            });
                        }}
                        cancelEdit={() => {
                            this.setState({
                                registrationFlowConfiguration: {
                                    ...registrationFlowConfiguration,
                                    form: JSON.parse(
                                        JSON.stringify(baseRegistrationFlowConfiguration.form)
                                    ),
                                },
                                editingRegistrationForm: false,
                            });
                        }}
                        emails={this.props.availableEmails || []}
                        orgId={orgId}
                        programId={programId}
                        addNewField={this.props.addNewField || (() => { })}
                        saveForm={this.saveRegistrationForm}
                        customFields={this.state.customFields || []}
                        groups={program.eventDefaults.groups || []}
                    />
                )}

                {pageBuilderModalOpen && (
                    <PageBuilderModal
                        scope="program"
                        isOpen={pageBuilderModalOpen}
                        toggle={() =>
                            this.setState({ pageBuilderModalOpen: !pageBuilderModalOpen })
                        }
                        lockForm={true}
                        page={baseRegistrationFlowConfiguration.page}
                        editedPage={registrationFlowConfiguration.page}
                        updatePage={this.updatePage}
                        cancelEdit={() => {
                            this.setState({
                                registrationFlowConfiguration: {
                                    ...registrationFlowConfiguration,
                                    page: baseRegistrationFlowConfiguration.page,
                                },
                                editing: false,
                            });
                        }}
                        event={this.props.program}
                        programId={this.props.program._id}
                        orgId={orgId}

                    />
                )}

                {emailBuilderModalOpen && (
                    <EmailEditor
                        isOpen={emailBuilderModalOpen}
                        emailTemplate={registrationFlowConfiguration.form.confirmationEmail}
                        orgId={orgId}
                        eventId={programId}
                        keyedMetadata={keyedMetadata}
                        keyedData={keyedData}
                        event={program}
                        branding={program.branding}
                        url={`${ENV}Organizations/${orgId}/emailrenderer`}
                        method={"post"}
                        postData={registrationFlowConfiguration.form.confirmationEmail}
                        toggle={() => {
                            this.setState({ emailBuilderModalOpen: false });
                        }}
                        update={this.updateTemplateHtml}
                        cancelEdit={this.cancelEdit}
                        links={{
                            getAssets: `Organizations/${orgId}/events/${programId}/assets`,
                            addAssets: `Organizations/${orgId}/events/${programId}/assets`,
                        }}
                    />
                )}

                {emailTemplateModalOpen && (
                    <TemplateCenterModal
                        isOpen={emailTemplateModalOpen}
                        orgId={orgId}
                        templates={this.state.templates}
                        platformTemplates={this.state.platformTemplates}
                        programId={programId}
                        event={this.props.program}
                        keyedMetadata={keyedMetadata}
                        toggle={() => {
                            this.setState({ emailTemplateModalOpen: false });
                        }}
                        addProgramEmail={(template) => {
                            this.setState(
                                {
                                    registrationFlowConfiguration: {
                                        ...registrationFlowConfiguration,
                                        form: {
                                            ...registrationFlowConfiguration.form,
                                            confirmationEmail: template,
                                        },
                                    },
                                    emailTemplateModalOpen: false,
                                },

                                this.saveRegistrationForm
                            );
                        }}
                        defaultSenderEmail={this.state.defaultSenderEmail}
                        defaultSenderName={this.state.defaultSenderName}
                        isTemplate={true}
                    />
                )}

                {this.state.editTicketModalOpen && (
                    <EditTicketModal
                        isOpen={this.state.editTicketModalOpen}
                        toggle={() => {
                            this.setState({ editTicketModalOpen: false });
                        }}
                        ticket={this.state.editingTicket}
                        flowId={this.props.match.params.flowId}
                        orgId={this.props.orgId}
                        programId={this.props.program._id}
                        updateTicket={(updatedTicket) => {
                            const updatedTickets =
                                this.state.registrationFlowConfiguration.tickets.map((ticket) =>
                                    ticket._id === updatedTicket._id ? updatedTicket : ticket
                                );

                            this.setState(
                                {
                                    registrationFlowConfiguration: {
                                        ...this.state.registrationFlowConfiguration,
                                        tickets: updatedTickets,
                                    },
                                    baseRegistrationFlowConfiguration: {
                                        ...this.state.baseRegistrationFlowConfiguration,
                                        tickets: updatedTickets,
                                    },
                                    editTicketModalOpen: false,
                                },
                                this.updateFlowTickets
                            );
                        }}
                    />
                )}

                {this.state.deleteTicketModalOpen && (
                    <DeleteTicketModal
                        isOpen={this.state.deleteTicketModalOpen}
                        toggle={() => {
                            this.setState({ deleteTicketModalOpen: false });
                        }}
                        ticket={this.state.deletingTicket}
                        flowId={this.props.match.params.flowId}
                        orgId={this.props.orgId}
                        programId={this.props.program._id}
                        onDelete={(ticketId) => {
                            const updatedTickets =
                                this.state.registrationFlowConfiguration.tickets.filter(
                                    (ticket) => ticket._id !== ticketId
                                );

                            this.setState(
                                {
                                    registrationFlowConfiguration: {
                                        ...this.state.registrationFlowConfiguration,
                                        tickets: updatedTickets,
                                    },
                                    baseRegistrationFlowConfiguration: {
                                        ...this.state.baseRegistrationFlowConfiguration,
                                        tickets: updatedTickets,
                                    },
                                    deleteTicketModalOpen: false,
                                },
                                this.updateFlowTickets
                            );
                        }}
                    />
                )}

                {this.state.duplicateTicketModalOpen && (
                    <DuplicateTicketModal
                        isOpen={this.state.duplicateTicketModalOpen}
                        toggle={() => {
                            this.setState({ duplicateTicketModalOpen: false });
                        }}
                        ticket={this.state.duplicatingTicket}
                        flowId={this.props.match.params.flowId}
                        orgId={this.props.orgId}
                        programId={this.props.program._id}
                        onDuplicate={(newTicket) => {
                            this.setState(
                                {
                                    registrationFlowConfiguration: {
                                        ...this.state.registrationFlowConfiguration,
                                        tickets: [
                                            ...this.state.registrationFlowConfiguration.tickets,
                                            newTicket,
                                        ],
                                    },
                                    baseRegistrationFlowConfiguration: {
                                        ...this.state.baseRegistrationFlowConfiguration,
                                        tickets: [
                                            ...this.state.baseRegistrationFlowConfiguration.tickets,
                                            newTicket,
                                        ],
                                    },
                                    duplicateTicketModalOpen: false,
                                },
                                this.updateFlowTickets
                            );
                        }}
                    />
                )}

                {deleteFlowModalOpen && (
                    <DeleteFlowModal
                        flow={baseRegistrationFlowConfiguration}
                        isOpen={deleteFlowModalOpen}
                        toggle={() => {
                            this.setState({ deleteFlowModalOpen: false });
                        }}
                        orgId={orgId}
                        programId={programId}
                        onDelete={(flowId) => {
                            this.props.removeFlow(flowId);
                            this.props.history.push(
                                `/${orgId}/program/${programId}/registrationFlows`
                            );
                        }}
                    />
                )}
            </div>
        );
    }
}

export default withRouter(RegistrationFlowSetup);
